import { render, staticRenderFns } from "./PersonalPlanEditPage.vue?vue&type=template&id=fc20bf8e&"
import script from "./PersonalPlanEditPage.vue?vue&type=script&lang=ts&"
export * from "./PersonalPlanEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports